export const PER_PAGE_BUYER_PAGINATION = 6;
